import { render, staticRenderFns } from "./ModalSalvarAutor.vue?vue&type=template&id=ebcf79da"
import script from "./ModalSalvarAutor.vue?vue&type=script&lang=ts"
export * from "./ModalSalvarAutor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports